// Single source of truth for company/contact details — swap here when real data is available.
export const SITE = {
  name: "NovaImmo",
  legalName: "NovaImmo Ltd",
  brn: "C23456789",
  url: "https://novaimmo.mu",
  email: "support@novaimmo.mu",
  phone: "+230 5 518 3296",
  address: "Royal Road, Grand Baie 30510",
  country: "Île Maurice",
  social: {
    instagram: "https://www.instagram.com/novaimmo_mu",
    facebook: "https://www.facebook.com/novaimmomauritius",
    tiktok: "https://www.tiktok.com/@novaimmo_mu",
    youtube: "https://www.youtube.com/@NovaImmo-mu",
  },
};

// ── ELYON (page /concept) — R3 ──────────────────────────────────────────────
// Produit masqué à la demande du client (projet pas encore abouti — réactivation prévue plus tard).
// La page reste accessible par URL directe (/concept) mais en noindex et hors sitemap.
// POUR RÉACTIVER ELYON (≈ 5 minutes) :
//   1. Passer ce flag à true  → le lien réapparaît dans le menu (Header) et le footer, le noindex est retiré.
//   2. Remettre "/concept" dans STATIC_ROUTES du sitemap (backend/server.py — chercher le repère "ELYON").
export const ELYON_VISIBLE = false;
